import { render, staticRenderFns } from "./ContractorBox.vue?vue&type=template&id=f656a24a&"
import script from "./ContractorBox.vue?vue&type=script&lang=js&"
export * from "./ContractorBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports